/*
Swiper.js loop mode has changed from v9 (see https://swiperjs.com/changelog#900-2023-02-01 for what changed in detail)
This function is supposed to maintain the initial loop behavior
*/

export const multiplySlidesIfNecessary = initialSlides => {
  // 12 the minimum number to ensure a seamless loop experience
  if (initialSlides?.length > 0 && initialSlides.length < 12) {
    const slides = [];
    // add slides as long as not greater than 12
    while (slides.length < 12) {
      slides.push(...initialSlides);
    }
    return slides;
  }
  return initialSlides;
};

export const determinedAmountOfLoopedSlides = multipliedSlides =>
  // duplicated slides need to be less than half of total slides in order to work properly
  Math.floor(multipliedSlides.length / 2 - 1);
